export default __webpack_public_path__ + "static/media/mountains-k5.f5b62ee5476495ae089411efabe4c78d.svg";